import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getQueryStringFromParams } from "../../api/utils/paramUtils";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

export function useDownloadTaxSubmissionF24Pdf() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async ({
            taxSubmissionId,
            taxPayerId,
            taxPayerPosition,
            delegationPosition,
        }: {
            taxSubmissionId: string;
            taxPayerId: string;
            taxPayerPosition: number;
            delegationPosition?: number;
        }) => {
            const queryString = getQueryStringFromParams({
                taxPayerPosition: taxPayerPosition.toString(),
                taxId: taxPayerId,
                ...(delegationPosition
                    ? {
                          delegationPosition: delegationPosition.toString(),
                      }
                    : {}),
            });
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${taxSubmissionId}/f24-pdf-preview?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return {
                content: new Uint8Array(await response.arrayBuffer()),
                type: response.headers.get("content-type") ?? "",
            };
        },
        meta: {
            errorMessage: t("errors.messages.getFulfilmentPdfPreview"),
        },
    });

    return mutation;
}
